<template>
	<div class="col-sm-3">
		<div class="box box-warning">
			<div class="box-header with-border">
				<h3 class="box-title"><i class="fa fa-book"></i> Dicionário</h3>
			</div>
			<div class="box-body">
				<ul class="list-group">
					<li
						v-for="(inpData, index) in getTerms"
						:key="index"
						class="list-group-item"
					>
						<b class="val1">{{ inpData.term }}</b>
						<i class="val2 text-primary">{{
							inpData.value || 'Indefinido'
						}}</i>
					</li>
				</ul>

				<ul v-if="$parent.getData.length == 0" class="list-group">
					<li class="list-group-item list-group-item-warning">
						Nenhum campo ainda!
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import { camelCase } from 'lodash';
	export default {
		computed: {
			getTerms() {
				return this.$parent.chForm.inputs.reduce((acc, item) => {
					if (item.type == 'table') {
						item.options.options.forEach((optItem) => {
							acc.push({
								term:
									'${' +
									this.keyGenerate(
										item.id + ' ' + optItem.value
									) +
									'}',
								value: item.value,
							});
						});
					} else {
						acc.push({
							term: '${' + this.keyGenerate(item.id) + '}',
							value: item.value,
						});
					}
					return acc;
					// console.log( this.keyGenerate(item.id),  item)
				}, []);
			},
		},
		methods: {
			keyGenerate(text) {
				text = text.replace(/\_/gi, ' ');
				text = camelCase(text);
				text = text.replace(text[0], text[0].toUpperCase());
				return text;
			},
		},
	};
</script>
<style scoped>
	b.val1 {
		display: block;
		margin: 0 0 -3px 0;
	}
	i.val2 {
		display: block;
		min-height: 20px;
		background-color: #f3f9ff;
	}
	.list-group-item {
		padding: 3px 9px;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/components/dicionario.vue